'use client';

import { type ReactNode, createContext, useContext, useMemo } from 'react';

type UpgradeDialogActionContextValue = {
  openUpgradeDialog: () => void;
};

const UpgradeDialogActionContext =
  createContext<UpgradeDialogActionContextValue | null>(null);

export function UpgradeDialogActionProvider({
  children,
  onOpenUpgradeDialog,
}: {
  children: ReactNode;
  onOpenUpgradeDialog: () => void;
}) {
  const value = useMemo(
    () => ({ openUpgradeDialog: onOpenUpgradeDialog }),
    [onOpenUpgradeDialog]
  );

  return (
    <UpgradeDialogActionContext.Provider value={value}>
      {children}
    </UpgradeDialogActionContext.Provider>
  );
}

export function useUpgradeDialogAction() {
  const value = useContext(UpgradeDialogActionContext);
  if (!value) {
    throw new Error(
      'useUpgradeDialogAction must be used inside UpgradeDialogActionProvider'
    );
  }

  return value;
}
